module.exports = __webpack_public_path__ + "img/lixi.c2cd268b.png";